export default Object.freeze({
  TOKEN: "TOKEN",
  ROLE: "ROLE",
  SEPARATE_PAGES_PREFERENCE: "SEPARATE_PAGES_PREFERENCE",
  SHARE_WITH_CHILDREN: "SHARE_WITH_CHILDREN",
  FIRST_TIME_VISITING: "FIRST_TIME_VISITING",
});
